import React from 'react';
// import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import QueueAnim from 'rc-queue-anim';
import { Row, Col } from 'antd';

import { getChildrenToRender } from '../utils/index';

function Feature6(props) {
  const { dataSource, isMobile, ...tagProps } = props;
  const { blockWrapper, titleWrapper } = dataSource;
  const childrenToRender = blockWrapper.children.map((item, i) => (
    <Col {...item} key={i.toString()}>
      <div {...item.children}>{item.children.children.map(getChildrenToRender)}</div>
    </Col>
  ));
  return (
    <div {...tagProps} {...dataSource.wrapper}>
      <div {...dataSource.page}>
        <div {...dataSource.titleWrapper}>{titleWrapper.children.map(getChildrenToRender)}</div>
        <div>
          <div class="normal-content">
            <QueueAnim
              key="queue"
              type="bottom"
              leaveReverse
              interval={50}
              component={Row}
              {...blockWrapper}
            >
              {childrenToRender}
            </QueueAnim>
          </div>
          <div class="mobile-content">
            <QueueAnim
              key="queue"
              type="bottom"
              leaveReverse
              interval={50}
              component={Row}
              {...blockWrapper}
            >
              {childrenToRender}
            </QueueAnim>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Feature6;
